module.exports = __webpack_public_path__ + "static/media/rowaad-mob.bef1eb93.webp";